import React from "react";
import WarTooltip from "./WarTooltip";
import UserTooltip from "./UserTooltip";
import DayTooltip from "./DayTooltip";
import RangeSelector from "./RangeSelector";
import TableFilter from "./TableFilter";
import Legend from "./Legend";

class UserTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rawInput: null,
      input: null,
      len: 30,
      warTooltipContent: null,
      warTooltipPosition: null,
      isWarTooltipVisible: false,

      userTooltipContent: null,
      userTooltipPosition: null,
      isUserTooltipVisible: false,

      dayTooltipContent: null,
      dayTooltipPosition: null,
      isDayTooltipVisible: false,

      filter: { warOnly: true, sort: "trophies" },
    };
  }

  //#region mouse events
  handleMouseEnterDay = (event, day, war) => {
    const rect = event.target.getBoundingClientRect();
    let pos = {
      top: rect.bottom + window.scrollY,
      left: rect.left + window.scrollX,
    };
    this.setState({
      dayTooltipContent: { day: day, war: war },
      isDayTooltipVisible: true,
      dayTooltipPosition: pos,
    });
  };

  handleMouseLeaveDay = () => {
    this.setState({ isDayTooltipVisible: false });
  };

  handleMouseEnterWar = (event, war) => {
    const rect = event.target.getBoundingClientRect();
    let pos = {
      top: rect.bottom + window.scrollY,
      left: rect.left + window.scrollX,
    };
    this.setState({
      warTooltipContent: war,
      isWarTooltipVisible: true,
      warTooltipPosition: pos,
    });
  };

  handleMouseLeaveWar = () => {
    this.setState({ isWarTooltipVisible: false });
  };

  handleMouseEnterUser = (event, user) => {
    const rect = event.target.getBoundingClientRect();
    let pos = {
      top: rect.top + window.scrollY,
      left: rect.right + window.scrollX,
    };
    this.setState({
      userTooltipContent: user,
      isUserTooltipVisible: true,
      userTooltipPosition: pos,
    });
  };

  handleMouseLeaveUser = () => {
    this.setState({ isUserTooltipVisible: false });
  };
  //#endregion mouse events

  setDayRange(len) {
    this.setState({ len: len }, () => this.loadData());
  }

  componentDidMount() {
    console.warn("console did mount");
    this.loadData();
  }

  loadData() {
    fetch("/api/GetTable?tag=2LQVPVC02&len=" + this.state.len)
      .then((response) => response.json())
      .then((data) =>
        this.setState({ rawInput: data }, () => this.filterInput())
      );
  }

  filterInput() {
    var sortedInput = this.state.rawInput;
    sortedInput.users = sortedInput.users.sort((a, b) => {
      var res = b[this.state.filter.sort] - a[this.state.filter.sort];
      if (res !== 0) return res;
      res = b.trophies - a.trophies;
      if (res !== 0) return res;
      res = b.thLevel - a.thLevel;
      if (res !== 0) return res;
      res = b.expLevel - a.expLevel;
      if (res !== 0) return res;
      return b.role - a.role;
    });
    this.setState({ input: sortedInput });
    console.warn(sortedInput);
  }

  addDaysToDate(srcDate, days) {
    var date = new Date(srcDate.valueOf());
    date.setDate(date.getDate() + days);
    return date;
  }

  renderWarCell(startDate, index) {
    const warResultClasses = ["warheaderlost", "warheadertie", "warheaderwon"];

    var war = this.state.input.wars[index];
    if (this.state.filter.warOnly && war === null) return null;
    return (
      <th
        className={
          war === null
            ? "warheadernone"
            : warResultClasses[war.result + 1] + " " + war.warType
        }
        onMouseEnter={
          war === null ? undefined : (e) => this.handleMouseEnterWar(e, war)
        }
        onMouseLeave={this.handleMouseLeaveWar}
      >
        {this.addDaysToDate(startDate, index).toLocaleDateString(undefined, {
          month: "numeric",
          day: "numeric",
        })}
      </th>
    );
  }

  renderDayCell(day, index) {
    var attacks = day.attacks;
    if (this.state.filter.warOnly && attacks === -2) return null;

    const warColors = [
      "dayNoWar",
      "dayOutWar",
      "dayZeroWar",
      "dayHalfWar",
      "dayFullWar",
    ];

    let war = this.state.input.wars[index];
    if (war !== null && war.numAttacks === attacks) {
      attacks = 2;
    }

    var style = warColors[attacks + 2] + (war ? " " + war.warType : "");

    if (day.inClan !== true) {
      return (
        <td
          tooltip-text={"out of clan"}
          className={"dayOutClan tooltip" + (war ? " " + war.warType : "")}
        ></td>
      );
    }

    if (attacks < 0) {
      const warTooltips = ["war not active", "not in war"];
      var tooltip = warTooltips[attacks + 2];
      return <td tooltip-text={tooltip} className={style + " tooltip"}></td>;
    } else {
      if (
        day.attacks === war.numAttacks &&
        ((day.attacks === 2 && day.stars === 3 + (3 << 3)) ||
          (day.attacks === 1 && day.stars === 3))
      )
        style += " perfect";
      return (
        <td
          className={style}
          onMouseEnter={(e) =>
            this.handleMouseEnterDay(e, day, this.state.input.wars[index])
          }
          onMouseLeave={this.handleMouseLeaveDay}
        ></td>
      );
    }
  }

  renderUserCell(user) {
    return (
      <td
        className={
          user.days[user.days.length - 1].inClan === true
            ? "userNameInClan firstCol"
            : "userNameOutClan firstCol"
        }
        onMouseEnter={
          user === null ? undefined : (e) => this.handleMouseEnterUser(e, user)
        }
        onMouseLeave={this.handleMouseLeaveUser}
      >
        {user.id.name}
      </td>
    );
  }

  render() {
    if (this.state.input === null) return "Loading";

    var data = this.state.input;
    var startDate = new Date(data.start);
    var header = [...Array(data.length).keys()].map((e) => {
      var index = data.length - e - 1;
      return this.renderWarCell(startDate, index);
    });

    var rows = data.users.map((user) => {
      var dayCells = user.days
        .slice(0)
        .reverse()
        .map((day, dayIndex) => {
          var index = data.length - dayIndex - 1;
          return this.renderDayCell(day, index);
        });
      return (
        <tr>
          {this.renderUserCell(user)}
          {dayCells}
        </tr>
      );
    });

    return (
      <div classname="maindiv">
        <h3 className="clantitle">Clan: {data.clanName}</h3>
        <div className="flexrow">
          <div className="flexcolumn">
            <RangeSelector
              rangeCallback={(x) => this.setDayRange(x)}
              len={this.state.len}
            />
            <TableFilter
              filter={this.state.filter}
              filterCallback={(newFilter) =>
                this.setState({ filter: newFilter }, () => this.filterInput())
              }
            />
          </div>
          <Legend />
        </div>
        <div className="tscroll">
          <table className="styled-table">
            <thead>
              <tr>
                <th></th>
                {header}
              </tr>
            </thead>
            <tbody>{rows}</tbody>
          </table>
          {this.state.isWarTooltipVisible && (
            <WarTooltip
              war={this.state.warTooltipContent}
              position={this.state.warTooltipPosition}
            />
          )}
          {this.state.isUserTooltipVisible && (
            <UserTooltip
              user={this.state.userTooltipContent}
              position={this.state.userTooltipPosition}
              wars={this.state.input.wars}
            />
          )}
          {this.state.isDayTooltipVisible && (
            <DayTooltip
              data={this.state.dayTooltipContent}
              position={this.state.dayTooltipPosition}
            />
          )}
        </div>
      </div>
    );
  }
}
export default UserTable;
